import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { omit } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
// Models
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { VisitorEntities } from 'client/data/models/visitor';
// Utils
import { FeaturesSpecsParams } from 'site-modules/shared/utils/features-specs/params';
import { buildSrpLink, srpLinkBuilderWithParamsConversion } from 'site-modules/shared/utils/srp-link-constructor';

// Constants
import { FEATURES_SPECS_CREATIVE_ID } from 'client/site-modules/shared/constants/features-specs';
// Components
import { Link } from 'site-modules/shared/components/link/link';

import './inventory-button.scss';

export function InventoryButton({
  makeModelSubmodelYear = null,
  params,
  visitorLocation = null,
  isBuyOnline = false,
  className = null,
  btnColor = 'primary-b',
}) {
  return (
    <Button
      tag={Link}
      to={
        isBuyOnline
          ? srpLinkBuilderWithParamsConversion(omit(params, ['year', 'styleId']), true)
          : buildSrpLink({ makeModelSubmodelYear, params, visitorLocation })
      }
      rel="nofollow"
      data-tracking-id={isBuyOnline ? 'view_search_result_online' : 'view_search_result'}
      size="lg"
      color={btnColor}
      className={classNames('buy-inventory-btn px-1 py-0_5 size-16 text-white text-transform-none', className, {
        'me-1': !isBuyOnline,
      })}
      data-tracking-parent={FEATURES_SPECS_CREATIVE_ID}
    >
      {isBuyOnline ? 'Buy Online' : 'Buy In-Store'}
    </Button>
  );
}

InventoryButton.propTypes = {
  params: FeaturesSpecsParams.isRequired,
  makeModelSubmodelYear: VehicleEntities.MakeModelSubmodelYear,
  visitorLocation: VisitorEntities.Location,
  className: PropTypes.string,
  btnColor: PropTypes.string,
  isBuyOnline: PropTypes.bool,
};
